<!--suppress JSUnresolvedReference -->
<template>
  <div>
    <div class="both-sides">
      <div class="container-left">
        <el-button icon="el-icon-s-fold" plain size="small" @click="$emit('switchCollapse')"></el-button>
        <div class="page-title">
            <span v-for="(route, i) in $route.matched" :key="i">
                {{ route.name }}
                <span v-if="i < $route.matched.length - 1">/</span>
            </span>
        </div>
      </div>
      <div class="top-right">
        <span style="margin-left: 5px;margin-right: 8px">{{ user.username }}</span>
        <el-dropdown>
          <i class="el-icon-user-solid"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="updatePassword()">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logOut()">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";
import {user} from "@/api/user";
import {utils} from "@/util/utils";


export default {
  name: 'TopHeader',

  computed: {
    ...mapState('user', ['user'])
  },

  methods: {
    updatePassword() {
      // todo: 修改密码
      this.$message.info("待开发");
    },


    async logOut() {
      user.logout().then(() => {
        utils.cookie.deleteCookie("wms_token");
        this.$router.push({name: "用户登录"});
      });
    },
  },
};

</script>

<style scoped>
.page-title {
  margin-left: 10px;
  font-weight: bold;
  font-size: 21px;
  color: #2f4050;
}


.s-width {
  margin: auto 6px
}

.breathing-light {
  width: 14px;
  height: 14px;
  border-radius: 50%; /* 使其变为圆形 */
  background-color: #208c18; /* 这是蓝色，你可以根据需要更改颜色 */

  /* 创建呼吸动画效果 */
  animation: breathe 2s infinite alternate;
}

@keyframes breathe {
  from {
    transform: scale(0.8); /* 开始时的大小 */
    opacity: 0.5; /* 开始时的不透明度 */
  }
  to {
    transform: scale(1); /* 结束时的大小 */
    opacity: 1; /* 结束时的不透明度 */
  }
}

.el-icon-user-solid {
  margin-right: 8px;
}

.both-sides {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 这里可以根据需要使用不同的值 */
  margin-top: 8px;
}

.container-left {
  display: flex;
  align-items: center;
}

.top-right {
  display: flex;
  align-items: center;
  font-size: 14px;
}
</style>
